export enum HappyReturnsDropoffMethod {
  ReturnBar = "return-bar",
  MailNolabel = "mail-nolabel",
  MailNoboxNolabel = "mail-nobox-nolabel",
}
